// @flow
import React from 'react';
import { Link } from 'react-router-dom';
// Styles
import './LoginHeader.css';
// Images
import logo from '../../landing-pages/images/logoVertical.svg';

const LoginHeader = () => {
  return (
    <div className="login-header-main">
      <div className="site-container">
        <Link to="/">
          <img className="login-header-logo" alt="Big Delivery" src={logo} />
        </Link>
      </div>
    </div>
  );
};

export default LoginHeader;
